import React, { createContext, useContext, useState, useCallback } from 'react';

const LanguageContext = createContext();

const translations = {
  de: {
    // Header
    nav: {
      home: 'Start',
      about: 'Gemeinde',
      events: 'Termine',
      visit: 'Gottesdienst',
      youth: 'Youth Arise',
      sermons: 'Predigten',
      contact: 'Kontakt',
      gallery: 'Galerie',
    },
    // Hero
    hero: {
      welcome: 'Willkommen bei der',
      churchName: 'ICG Hannover',
      subtitle: 'Eine internationale Familie von Glaeubigen, die gemeinsam Jesus nachfolgen und Menschen aus allen Nationen willkommen heissen. Seit 2009.',
      serviceTime: 'Jeden Sonntag um 16:00 Uhr',
      onsite: 'Vor Ort & Online',
      ctaVisit: 'Gottesdienst besuchen',
      ctaContact: 'Gemeinde kennenlernen',
      years: 'Jahre Gemeinschaft',
      nations: 'Nationen vertreten',
      members: 'Gemeindeglieder',
    },
    // Welcome / Gemeinde kennenlernen
    welcome: {
      badge: 'Du bist willkommen!',
      title: 'Gemeinde kennenlernen',
      subtitle: 'Was dich bei uns erwartet',
      card1Title: 'Lebendiger Gottesdienst',
      card1Desc: 'Erlebe mitreissenden Lobpreis, kraftvolle Predigten und eine Atmosphaere, in der du Gott persoenlich begegnen kannst.',
      card2Title: 'Echte Gemeinschaft',
      card2Desc: 'Bei uns findest du mehr als einen Sonntagsgottesdienst. Wir sind fuereinander da \u2013 in Kleingruppen, bei gemeinsamen Mahlzeiten und im Alltag.',
      card3Title: 'Raum fuer jeden',
      card3Desc: 'Ob jung oder alt, allein oder als Familie, egal welcher Hintergrund \u2013 hier hat jeder einen Platz und wird so angenommen, wie er ist.',
      card4Title: 'International & Vielfaeltig',
      card4Desc: 'Menschen aus ueber 8 Nationen beten, singen und leben hier gemeinsam den Glauben. Vielfalt ist keine Herausforderung \u2013 sie ist unser Geschenk.',
      cta: 'Komm diesen Sonntag vorbei',
    },
    // About
    about: {
      title: 'Wer wir sind',
      subtitle: 'Unsere Geschichte, unsere Mission, unser Herz.',
      desc: 'Seit 2009 ist die ICG Hannover ein Zuhause fuer Menschen aus aller Welt. Was als kleine Gebetsgruppe begann, ist heute eine lebendige Gemeinde mit ueber 35 Mitgliedern aus 8 Nationen \u2013 eine internationale Familie von Glaeubigen, die gemeinsam Jesus nachfolgen.',
      mission: 'Unsere Mission',
      missionText: 'Eine internationale Familie von Glaeubigen, die gemeinsam Jesus nachfolgen und Menschen aus allen Nationen willkommen heissen.',
      values: 'Unsere Werte',
      familyTitle: 'Eine Familie aus allen Nationen',
      worship: 'Lobpreis',
      worshipText: 'Leidenschaftliche Anbetung, die Herzen beruehrt',
      community: 'Gemeinschaft',
      communityText: 'Fuereinander da sein \u2013 in guten und schweren Zeiten',
      teaching: 'Lehre',
      teachingText: 'Gottes Wort lebensnah und verstaendlich vermitteln',
      service: 'Dienst',
      serviceText: 'Mit unseren Gaben anderen Menschen dienen',
      visitBtn: 'Besuche uns',
    },
    // Events
    events: {
      title: 'Unsere Termine',
      subtitle: 'Das aktuelle Wochenprogramm der ICG Hannover. Wir freuen uns auf dich!',
      newsletter: 'Verpasse keinen Termin!',
      newsletterSub: 'Melde dich fuer unseren Newsletter an und erhalte aktuelle Infos direkt in dein Postfach.',
      emailPlaceholder: 'Deine E-Mail-Adresse',
      subscribe: 'Anmelden',
    },
    // VisitUs
    visit: {
      title: 'Komm zum Gottesdienst!',
      subtitle: 'Jeden Sonntag feiern wir gemeinsam \u2013 mit Lobpreis, einer ermutigenden Predigt und echter Gemeinschaft. Komm vorbei oder schau online zu!',
      when: 'Wann?',
      where: 'Wo?',
      online: 'Online?',
      everySunday: 'Jeden Sonntag',
      time: '16:00 Uhr',
      address: 'Am Klagesmarkt 29',
      city: '30159 Hannover',
      livestream: 'Live-Stream',
      route: 'Route planen',
      joinOnline: 'Online teilnehmen',
    },
    // Youth Arise
    youth: {
      badge: 'Unsere Jugend',
      subtitle: 'Ein Ort fuer junge Menschen, die gemeinsam wachsen, Glauben leben, Freundschaften aufbauen und ihre Generation fuer Jesus begeistern wollen.',
      cta: 'Mehr erfahren',
      tags: ['Gemeinschaft', 'Glaube', 'Freundschaft', 'Jesus'],
    },
    // Sermons
    sermons: {
      title: 'Predigten',
      subtitle: 'Lass dich von Gottes Wort inspirieren. Hier findest du aktuelle und vergangene Predigten zum Nachhoeren.',
      latest: 'Neueste Predigt',
      more: 'Weitere Predigten',
      watchNow: 'Jetzt ansehen',
      allOnYoutube: 'Alle Predigten auf YouTube',
      videoPlaceholder: 'Video wird hier abgespielt',
      playerSub: 'YouTube / Vimeo Player',
    },
    // Contact
    contact: {
      title: 'Wir freuen uns auf dich!',
      subtitle: 'Du hast Fragen, moechtest mehr erfahren oder einfach Hallo sagen? Melde dich bei uns \u2013 wir sind fuer dich da.',
      callUs: 'Anrufen',
      whatsapp: 'WhatsApp',
      email: 'E-Mail',
      route: 'Route',
      formTitle: 'Schreib uns eine Nachricht',
      name: 'Dein Name',
      emailField: 'Deine E-Mail',
      subject: 'Betreff',
      message: 'Deine Nachricht',
      send: 'Nachricht senden',
      sending: 'Wird gesendet...',
      hours: 'Gottesdienstzeiten',
      sundayService: 'Sonntag: 16:00 Uhr (Gottesdienst)',
      thursdayPrayer: 'Donnerstag: Gebets- und Bibelstunde',
      phone: 'Telefon',
      address: 'Adresse',
      ctaText: 'Egal ob per Telefon, WhatsApp, E-Mail oder persoenlich \u2013 wir freuen uns, von dir zu hoeren!',
      whatsappGroup: 'WhatsApp-Gruppe',
      whatsappGroupSub: 'Tritt unserer Gemeinde-Gruppe bei',
    },
    // Instagram
    instagram: {
      follow: 'Folge uns auf Instagram',
      subtitle: 'Einblicke in unser Gemeindeleben, Gottesdienste und besondere Momente.',
      cta: 'Auf Instagram folgen',
    },
    // Footer
    footer: {
      rights: 'Alle Rechte vorbehalten.',
      privacy: 'Datenschutz',
      imprint: 'Impressum',
      terms: 'AGB',
    },
    // Mobile Nav
    mobileNav: {
      home: 'Start',
      events: 'Termine',
      service: 'Gottesdienst',
      contact: 'Kontakt',
    },
    cookies: {
      text: 'Diese Website verwendet Cookies und aehnliche Technologien, um Ihnen die bestmoegliche Nutzung zu ermoeglichen. Weitere Informationen finden Sie in unserer',
      learnMore: 'Datenschutzerklaerung',
      accept: 'Akzeptieren',
      decline: 'Ablehnen',
    },
  },
  en: {
    nav: {
      home: 'Home',
      about: 'Community',
      events: 'Events',
      visit: 'Service',
      youth: 'Youth Arise',
      sermons: 'Sermons',
      contact: 'Contact',
      gallery: 'Gallery',
    },
    hero: {
      welcome: 'Welcome to',
      churchName: 'ICG Hannover',
      subtitle: 'An international family of believers who follow Jesus together and welcome people from all nations. Since 2009.',
      serviceTime: 'Every Sunday at 4:00 PM',
      onsite: 'On-site & Online',
      ctaVisit: 'Visit our service',
      ctaContact: 'Get to know us',
      years: 'Years of community',
      nations: 'Nations represented',
      members: 'Church members',
    },
    welcome: {
      badge: 'You are welcome!',
      title: 'Get to know our community',
      subtitle: 'What you can expect with us',
      card1Title: 'Vibrant Worship',
      card1Desc: 'Experience uplifting worship, powerful sermons and an atmosphere where you can encounter God personally.',
      card2Title: 'Real Community',
      card2Desc: 'With us, you will find more than a Sunday service. We are there for each other \u2013 in small groups, shared meals and everyday life.',
      card3Title: 'A place for everyone',
      card3Desc: 'Whether young or old, single or family, whatever your background \u2013 everyone has a place here and is accepted as they are.',
      card4Title: 'International & Diverse',
      card4Desc: 'People from over 8 nations pray, sing and live their faith together here. Diversity is not a challenge \u2013 it is our gift.',
      cta: 'Come by this Sunday',
    },
    about: {
      title: 'Who we are',
      subtitle: 'Our story, our mission, our heart.',
      desc: 'Since 2009, ICG Hannover has been a home for people from all over the world. What started as a small prayer group has grown into a vibrant community of over 35 members from 8 nations \u2013 an international family of believers who follow Jesus together.',
      mission: 'Our Mission',
      missionText: 'An international family of believers who follow Jesus together and welcome people from all nations.',
      values: 'Our Values',
      familyTitle: 'A family from all nations',
      worship: 'Worship',
      worshipText: 'Passionate worship that touches hearts',
      community: 'Community',
      communityText: 'Being there for each other \u2013 in good and tough times',
      teaching: 'Teaching',
      teachingText: 'Sharing God\'s Word in a relatable and understandable way',
      service: 'Service',
      serviceText: 'Serving others with our gifts',
      visitBtn: 'Visit us',
    },
    events: {
      title: 'Our Events',
      subtitle: 'The current weekly schedule of ICG Hannover. We look forward to seeing you!',
      newsletter: 'Don\'t miss any event!',
      newsletterSub: 'Subscribe to our newsletter and receive current info straight to your inbox.',
      emailPlaceholder: 'Your email address',
      subscribe: 'Subscribe',
    },
    visit: {
      title: 'Come to our service!',
      subtitle: 'Every Sunday we celebrate together \u2013 with worship, an encouraging sermon and real community. Come by or watch online!',
      when: 'When?',
      where: 'Where?',
      online: 'Online?',
      everySunday: 'Every Sunday',
      time: '4:00 PM',
      address: 'Am Klagesmarkt 29',
      city: '30159 Hannover',
      livestream: 'Live Stream',
      route: 'Plan your route',
      joinOnline: 'Join online',
    },
    youth: {
      badge: 'Our Youth',
      subtitle: 'A place for young people who want to grow together, live faith, build friendships and inspire their generation for Jesus.',
      cta: 'Learn more',
      tags: ['Community', 'Faith', 'Friendship', 'Jesus'],
    },
    sermons: {
      title: 'Sermons',
      subtitle: 'Be inspired by God\'s Word. Find current and past sermons to listen to here.',
      latest: 'Latest Sermon',
      more: 'More Sermons',
      watchNow: 'Watch now',
      allOnYoutube: 'All sermons on YouTube',
      videoPlaceholder: 'Video plays here',
      playerSub: 'YouTube / Vimeo Player',
    },
    contact: {
      title: 'We look forward to hearing from you!',
      subtitle: 'Have questions, want to learn more or just say hello? Get in touch \u2013 we are here for you.',
      callUs: 'Call us',
      whatsapp: 'WhatsApp',
      email: 'Email',
      route: 'Directions',
      formTitle: 'Send us a message',
      name: 'Your name',
      emailField: 'Your email',
      subject: 'Subject',
      message: 'Your message',
      send: 'Send message',
      sending: 'Sending...',
      hours: 'Service times',
      sundayService: 'Sunday: 4:00 PM (Service)',
      thursdayPrayer: 'Thursday: Prayer & Bible study',
      phone: 'Phone',
      address: 'Address',
      ctaText: 'Whether by phone, WhatsApp, email or in person \u2013 we look forward to hearing from you!',
      whatsappGroup: 'WhatsApp Group',
      whatsappGroupSub: 'Join our community group',
    },
    instagram: {
      follow: 'Follow us on Instagram',
      subtitle: 'Insights into our community life, services and special moments.',
      cta: 'Follow on Instagram',
    },
    footer: {
      rights: 'All rights reserved.',
      privacy: 'Privacy Policy',
      imprint: 'Imprint',
      terms: 'Terms',
    },
    mobileNav: {
      home: 'Home',
      events: 'Events',
      service: 'Service',
      contact: 'Contact',
    },
    cookies: {
      text: 'This website uses cookies and similar technologies to provide you with the best possible experience. For more information, please see our',
      learnMore: 'Privacy Policy',
      accept: 'Accept',
      decline: 'Decline',
    },
  },
  fr: {
    nav: {
      home: 'Accueil',
      about: 'Communaute',
      events: 'Programme',
      visit: 'Culte',
      youth: 'Youth Arise',
      sermons: 'Predications',
      contact: 'Contact',
      gallery: 'Galerie',
    },
    hero: {
      welcome: 'Bienvenue a',
      churchName: 'ICG Hannover',
      subtitle: 'Une famille internationale de croyants qui suivent Jesus ensemble et accueillent des personnes de toutes les nations. Depuis 2009.',
      serviceTime: 'Chaque dimanche a 16h00',
      onsite: 'Sur place & en ligne',
      ctaVisit: 'Venir au culte',
      ctaContact: 'Decouvrir la communaute',
      years: 'Annees de communaute',
      nations: 'Nations representees',
      members: 'Membres',
    },
    welcome: {
      badge: 'Tu es le bienvenu!',
      title: 'Decouvrir la communaute',
      subtitle: 'Ce qui t\'attend chez nous',
      card1Title: 'Culte vivant',
      card1Desc: 'Vis une louange entrainante, des predications puissantes et une atmosphere ou tu peux rencontrer Dieu personnellement.',
      card2Title: 'Vraie communaute',
      card2Desc: 'Chez nous, tu trouveras plus qu\'un culte dominical. Nous sommes la les uns pour les autres \u2013 en petits groupes, repas partages et au quotidien.',
      card3Title: 'Une place pour chacun',
      card3Desc: 'Jeune ou age, seul ou en famille, peu importe ton parcours \u2013 chacun a sa place ici et est accepte tel qu\'il est.',
      card4Title: 'International & Diversifie',
      card4Desc: 'Des personnes de plus de 8 nations prient, chantent et vivent leur foi ensemble ici. La diversite n\'est pas un defi \u2013 c\'est notre cadeau.',
      cta: 'Viens ce dimanche',
    },
    about: {
      title: 'Qui sommes-nous',
      subtitle: 'Notre histoire, notre mission, notre coeur.',
      desc: 'Depuis 2009, ICG Hannover est un foyer pour des personnes du monde entier. Ce qui a commence comme un petit groupe de priere est devenu une communaute vivante de plus de 35 membres de 8 nations \u2013 une famille internationale de croyants qui suivent Jesus ensemble.',
      mission: 'Notre Mission',
      missionText: 'Une famille internationale de croyants qui suivent Jesus ensemble et accueillent des personnes de toutes les nations.',
      values: 'Nos Valeurs',
      familyTitle: 'Une famille de toutes les nations',
      worship: 'Louange',
      worshipText: 'Adoration passionnee qui touche les coeurs',
      community: 'Communaute',
      communityText: 'Etre la les uns pour les autres \u2013 dans les bons et les mauvais moments',
      teaching: 'Enseignement',
      teachingText: 'Partager la Parole de Dieu de maniere accessible et comprehensible',
      service: 'Service',
      serviceText: 'Servir les autres avec nos dons',
      visitBtn: 'Venez nous rendre visite',
    },
    events: {
      title: 'Nos rendez-vous',
      subtitle: 'Le programme hebdomadaire actuel de l\'ICG Hannover. Nous nous rejouissons de vous voir!',
      newsletter: 'Ne manquez aucun evenement!',
      newsletterSub: 'Inscrivez-vous a notre newsletter et recevez les infos actuelles directement dans votre boite mail.',
      emailPlaceholder: 'Votre adresse e-mail',
      subscribe: 'S\'inscrire',
    },
    visit: {
      title: 'Viens au culte!',
      subtitle: 'Chaque dimanche, nous celebrons ensemble \u2013 avec la louange, une predication encourageante et une vraie communaute. Viens sur place ou regarde en ligne!',
      when: 'Quand?',
      where: 'Ou?',
      online: 'En ligne?',
      everySunday: 'Chaque dimanche',
      time: '16h00',
      address: 'Am Klagesmarkt 29',
      city: '30159 Hannover',
      livestream: 'En direct',
      route: 'Planifier l\'itineraire',
      joinOnline: 'Participer en ligne',
    },
    youth: {
      badge: 'Notre Jeunesse',
      subtitle: 'Un lieu pour les jeunes qui veulent grandir ensemble, vivre la foi, construire des amities et inspirer leur generation pour Jesus.',
      cta: 'En savoir plus',
      tags: ['Communaute', 'Foi', 'Amitie', 'Jesus'],
    },
    sermons: {
      title: 'Predications',
      subtitle: 'Laissez-vous inspirer par la Parole de Dieu. Retrouvez ici les predications actuelles et passees.',
      latest: 'Derniere predication',
      more: 'Autres predications',
      watchNow: 'Regarder maintenant',
      allOnYoutube: 'Toutes les predications sur YouTube',
      videoPlaceholder: 'La video est lue ici',
      playerSub: 'Lecteur YouTube / Vimeo',
    },
    contact: {
      title: 'Nous nous rejouissons de te rencontrer!',
      subtitle: 'Tu as des questions, tu veux en savoir plus ou simplement dire bonjour? Contacte-nous \u2013 nous sommes la pour toi.',
      callUs: 'Appeler',
      whatsapp: 'WhatsApp',
      email: 'E-Mail',
      route: 'Itineraire',
      formTitle: 'Envoyez-nous un message',
      name: 'Ton nom',
      emailField: 'Ton e-mail',
      subject: 'Objet',
      message: 'Ton message',
      send: 'Envoyer le message',
      sending: 'Envoi en cours...',
      hours: 'Horaires des cultes',
      sundayService: 'Dimanche: 16h00 (Culte)',
      thursdayPrayer: 'Jeudi: Priere et etude biblique',
      phone: 'Telephone',
      address: 'Adresse',
      ctaText: 'Que ce soit par telephone, WhatsApp, e-mail ou en personne \u2013 nous nous rejouissons de te rencontrer!',
      whatsappGroup: 'Groupe WhatsApp',
      whatsappGroupSub: 'Rejoins notre groupe communautaire',
    },
    instagram: {
      follow: 'Suivez-nous sur Instagram',
      subtitle: 'Apercu de notre vie communautaire, des cultes et des moments speciaux.',
      cta: 'Suivre sur Instagram',
    },
    footer: {
      rights: 'Tous droits reserves.',
      privacy: 'Protection des donnees',
      imprint: 'Mentions legales',
      terms: 'CGV',
    },
    mobileNav: {
      home: 'Accueil',
      events: 'Programme',
      service: 'Culte',
      contact: 'Contact',
    },
    cookies: {
      text: 'Ce site utilise des cookies et des technologies similaires pour vous offrir la meilleure experience possible. Pour plus d\'informations, consultez notre',
      learnMore: 'Politique de confidentialite',
      accept: 'Accepter',
      decline: 'Refuser',
    },
  },
};

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => {
    if (typeof window !== 'undefined') {
      return localStorage.getItem('icg-lang') || 'de';
    }
    return 'de';
  });

  const switchLanguage = useCallback((newLang) => {
    setLang(newLang);
    localStorage.setItem('icg-lang', newLang);
  }, []);

  const t = useCallback((key) => {
    const keys = key.split('.');
    let result = translations[lang];
    for (const k of keys) {
      if (result && result[k] !== undefined) {
        result = result[k];
      } else {
        // Fallback to German
        let fallback = translations['de'];
        for (const fk of keys) {
          fallback = fallback?.[fk];
        }
        return fallback || key;
      }
    }
    return result;
  }, [lang]);

  return (
    <LanguageContext.Provider value={{ lang, switchLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}

export default LanguageContext;
